import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .tabby-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
    }

    .intro {
      grid-column: 2 / 8;
      grid-row: 2;
      display: flex;
      flex-direction: column;
      gap: calc(32rem / var(--default-rem-px-count));
      padding-bottom: calc(40rem / var(--default-rem-px-count));
      width: 100%;
      color: var(--block-text-color, #222);
    }

    .intro::part(body) {
      display: flex;
      flex-direction: column;
      gap: calc(32rem / var(--default-rem-px-count));
    }

    /* The intro row is baseline-aligned from 600px, but cta-text sets
       align-self on its own :host; only a rule from out here lets it join
       the baseline group. */
    .learn-more {
      flex: 0 0 auto;
      align-self: baseline;
    }

    .table-scroll {
      grid-column: 2 / 8;
      grid-row: 3;
      width: 100%;
      overflow-x: auto;
      /* Firefox scrollbar */
      scrollbar-width: thin;
      scrollbar-color: #232322 transparent;
    }

    .table-scroll::-webkit-scrollbar {
      height: calc(6rem / var(--default-rem-px-count));
    }

    .table-scroll::-webkit-scrollbar-track {
      background: transparent;
    }

    .table-scroll::-webkit-scrollbar-thumb {
      background-color: #232322;
      border-radius: calc(8rem / var(--default-rem-px-count));
    }

    .matrix {
      /*
        Separated, not collapsed: WebKit resolves collapsed border widths to
        whole device pixels, so a 0.5px hairline floors to zero and the grid
        vanishes on iOS Safari. Each cell draws its own right/bottom edge, and
        the first column and first body row close the outer frame, so no edge
        is drawn twice.
      */
      border-collapse: separate;
      border-spacing: 0;
      table-layout: fixed;
      min-width: 100%;
      color: var(--block-text-color, #222);
    }

    .cell {
      width: calc(195rem / var(--default-rem-px-count));
      min-width: calc(195rem / var(--default-rem-px-count));
      padding: calc(12rem / var(--default-rem-px-count))
        calc(10rem / var(--default-rem-px-count));
      text-align: left;
      vertical-align: middle;
      box-sizing: border-box;
    }

    .header-cell {
      height: calc(40rem / var(--default-rem-px-count));
      padding-top: calc(5rem / var(--default-rem-px-count));
      padding-bottom: calc(25rem / var(--default-rem-px-count));
      border: none;
      font-size: var(--fs-label-small);
      line-height: var(--lh-label-small);
      letter-spacing: var(--ls-label-small);
      font-weight: var(--fw-medium);
      text-transform: uppercase;
      color: var(--block-text-color, #222);
    }

    .corner-cell {
      /* Top-left cell. Blank by default; matrix_table.corner_text fills it
         when set. */
    }

    .body-cell,
    .feature-cell {
      border-right: 0.5px solid #ccc;
      border-bottom: 0.5px solid #ccc;
    }

    .feature-cell {
      border-left: 0.5px solid #ccc;
    }

    tbody tr:first-child .cell {
      border-top: 0.5px solid #ccc;
    }

    .body-cell {
      height: calc(70rem / var(--default-rem-px-count));
      font-size: var(--fs-body-small);
      line-height: var(--lh-body-small);
      letter-spacing: var(--ls-body-small);
      font-weight: var(--fw-regular);
    }

    .feature-cell {
      height: calc(70rem / var(--default-rem-px-count));
      font-size: var(--fs-label-small);
      line-height: var(--lh-label-small);
      letter-spacing: var(--ls-label-small);
      font-weight: var(--fw-medium);
    }

    .cell-with-tooltip {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: calc(10rem / var(--default-rem-px-count));
    }

    .cell-text {
      min-width: 0;
    }

    @media (min-width: 600px) {
      .intro {
        grid-column: 2 / 14;
        padding-bottom: calc(60rem / var(--default-rem-px-count));
      }

      .intro::part(body) {
        flex-direction: row;
        justify-content: space-between;
        align-items: baseline;
        gap: calc(32rem / var(--default-rem-px-count));
      }

      .intro::part(description) {
        flex: 1 1 0;
        min-width: 0;
        max-width: calc(551rem / var(--default-rem-px-count));
      }

      .table-scroll {
        grid-column: 2 / 14;
      }
    }

    @media (min-width: 1024px) {
      .intro {
        flex-direction: row;
        align-items: baseline;
      }

      .intro::part(header) {
        flex: 1 1 0;
        min-width: 0;
        max-width: calc(318rem / var(--default-rem-px-count));
      }

      .intro::part(body) {
        flex: 1 1 0;
        min-width: 0;
      }
    }
  `,
];
